import { all, call, delay, put, takeLatest, select, takeEvery } from 'redux-saga/effects'
import { history } from 'index'
import {
  changeEmail,
  confirmEmail,
  getOnboardDetails,
  load,
  login,
  recoverPassword,
  register,
  resendEmail,
  resetPassword,
} from 'api/user'
import store from 'store'
import MenuAction from 'redux/menu/actions'
import { register as registerBusiness } from 'api/business'
import RootAction from 'redux/actions'
import actions from './actions'
import { userStateData } from './reducers'

export function* REGISTER({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      registering: true,
    },
  })
  const { response, error } = yield call(register, payload)
  store.set(`user.email`, payload.email)
  yield put({
    type: actions.SET_STATE,
    payload: {
      email: payload.email,
      registering: false,
    },
  })
  if (response) {
    yield history.push('/confirm-email')
  } else {
    const { errors } = error.response?.data
    yield put({
      type: actions.SET_ERROR_STATE,
      payload: {
        register: errors,
      },
    })
  }
}

export function* CHANGE_EMAIL({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      changingEmail: true,
    },
  })
  const { response, error } = yield call(changeEmail, payload)
  yield put({
    type: actions.SET_STATE,
    payload: {
      changingEmail: false,
    },
  })
  if (response) {
    store.set(`user.email`, payload.email)
    yield put({
      type: actions.SET_STATE,
      payload: {
        email: payload.new_email,
        displayChangeEmailModal: false,
      },
    })
  } else {
    const { errors } = error.response?.data
    yield put({
      type: actions.SET_ERROR_STATE,
      payload: {
        change: errors,
      },
    })
  }
}

export function* RESEND_EMAIL({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      canResendEmail: false,
      resendingEmail: true,
    },
  })
  const { response } = yield call(resendEmail, payload)
  yield put({
    type: actions.SET_STATE,
    payload: {
      resendingEmail: false,
    },
  })
  if (response) {
    yield delay(10000)
    yield put({
      type: actions.SET_STATE,
      payload: {
        canResendEmail: true,
      },
    })
  } else {
    yield put({
      type: actions.SET_STATE,
      payload: {
        canResendEmail: true,
      },
    })
  }
}

export function* CONFIRM_EMAIL({ payload }) {
  payload.device_id = Array(15)
    .fill(null)
    .map(() => Math.random().toString(36).substr(2))
    .join('')
    .slice(0, 48)
  yield put({
    type: actions.SET_STATE,
    payload: {
      confirming: true,
    },
  })
  const { response } = yield call(confirmEmail, payload)
  yield put({
    type: actions.SET_STATE,
    payload: {
      confirming: false,
    },
  })
  if (response) {
    const { access_token } = response.data
    yield call(HANDLE_USER_TOKEN, access_token)
    yield call(LOAD_CURRENT_ACCOUNT)
  }
}

function* HANDLE_USER_TOKEN(access_token) {
  store.set(`user.accessToken`, access_token)
  console.log('access_token', access_token)
  yield put({
    type: actions.SET_STATE,
    payload: {
      accessToken: access_token,
      email: null,
      canResendEmail: false,
      resendEmail: false,
    },
  })
  yield history.push('/')
}

export function* LOGIN({ payload }) {
  payload.device_id = Array(15)
    .fill(null)
    .map(() => Math.random().toString(36).substr(2))
    .join('')
    .slice(0, 48)
  yield put({
    type: actions.SET_STATE,
    payload: {
      loggingIn: true,
    },
  })
  const { response } = yield call(login, payload)
  yield put({
    type: actions.SET_STATE,
    payload: {
      loggingIn: false,
    },
  })
  if (response) {
    const { access_token } = response.data
    yield call(HANDLE_USER_TOKEN, access_token)
    yield call(LOAD_CURRENT_ACCOUNT)
  }
}

export function* LOAD_CURRENT_ACCOUNT() {
  if (!store.get('user.accessToken')) return
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })
  const { response } = yield call(load)

  if (response) {
    const { user, business } = response.data
    const can_register = false
    store.set(`user.data`, user)
    store.set(`user.canRegister`, can_register)
    store.set(`user.business`, business)
    store.set(`user.location`, business.location)
    const { getting_started: onboard_status = {} } = yield call(getOnboardDetails)
    // console.log('onboard_status', onboard_status)
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
      },
    })
    yield put({
      type: actions.SET_STATE,
      payload: {
        data: user,
        onboard_status,
        canRegister: can_register,
      },
    })

    if (business.primary_user_id === user._id) {
      store.set(`user.role`, 'Business Owner')
      yield put({
        type: actions.SET_STATE,
        payload: {
          role: 'Business Owner',
        },
      })
    }
    yield put({
      type: actions.SET_STATE,
      payload: {
        business,
      },
    })
    // const payload = {
    //   location: business.location
    // }
    yield put({
      type: actions.SET_STATE,
      payload: {
        location: business.location,
      },
    })
    yield put({
      type: MenuAction.SET_DATA,
    })
    // yield call(SET_LOCATION, { payload })
  }

  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
    },
  })
}

export function* SET_LOCATION({ payload }) {
  const { location } = payload
  store.set(`user.location`, location)
  yield put({
    type: actions.SET_STATE,
    payload: {
      location,
    },
  })
  yield put({
    type: MenuAction.SET_DATA,
  })
}

export function* RECOVER_PASSWORD({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      recovering: true,
    },
  })
  const { response, error } = yield call(recoverPassword, payload)
  yield put({
    type: actions.SET_STATE,
    payload: {
      recovering: false,
    },
  })
  if (response) {
    yield history.push('/')
  } else {
    const { errors } = error.response?.data
    yield put({
      type: actions.SET_ERROR_STATE,
      payload: {
        recover: errors,
      },
    })
  }
}

export function* RESET_PASSWORD({ payload }) {
  payload.device_id = Array(15)
    .fill(null)
    .map(() => Math.random().toString(36).substr(2))
    .join('')
    .slice(0, 48)
  yield put({
    type: actions.SET_STATE,
    payload: {
      resetting: true,
    },
  })
  const { response, error } = yield call(resetPassword, payload)
  yield put({
    type: actions.SET_STATE,
    payload: {
      resetting: false,
    },
  })
  if (response) {
    const { access_token } = response.data
    yield call(HANDLE_USER_TOKEN, access_token)
    yield call(LOAD_CURRENT_ACCOUNT)
  } else {
    const { errors } = error.response?.data
    yield put({
      type: actions.SET_ERROR_STATE,
      payload: {
        reset: errors,
      },
    })
  }
}

export function* LOGOUT() {
  yield call(CLEAR_USER)
}

export function* CLEAR_USER() {
  store.set(`user.accessToken`, null)
  store.clearAll()
  yield put({
    type: RootAction.CLEAR_STATE,
  })
  yield put({
    type: actions.SET_STATE,
    payload: userStateData,
  })
}

export function* REGISTER_BUSINESS({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      submitting: true,
    },
  })
  const { response, error } = yield call(registerBusiness, payload)
  yield put({
    type: actions.SET_STATE,
    payload: {
      submitting: false,
    },
  })
  if (response) {
    yield call(LOAD_CURRENT_ACCOUNT)
  } else {
    const { errors } = error.response?.data
    yield put({
      type: actions.SET_ERROR_STATE,
      payload: {
        business: errors,
      },
    })
  }
}

// update onboardstatus
export function* updateOnBoardStatus({ payload }) {
  // check if payload is onboarded.
  // Eg: payload: "loyalty_card_design" will check if loyalty_card_design has boarded
  console.log('{payload}', payload)
  const hasBoarded = yield select((state) => state?.user?.onboard_status?.[payload] ?? false)
  console.log(`${payload} is${hasBoarded ? ' ' : 'not '}boarded`)
  if (!hasBoarded) {
    try {
      const { getting_started } = yield call(getOnboardDetails)
      if (getting_started) {
        yield put({
          type: actions.SET_STATE,
          payload: { onboard_status: getting_started },
        })
      }
    } catch (err) {
      console.log(err)
    }
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(actions.REGISTER, REGISTER),
    takeLatest(actions.CHANGE_EMAIL, CHANGE_EMAIL),
    takeLatest(actions.RESEND_EMAIL, RESEND_EMAIL),
    takeLatest(actions.CONFIRM_EMAIL, CONFIRM_EMAIL),
    takeLatest(actions.LOGIN, LOGIN),
    takeLatest(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    takeLatest(actions.RECOVER_PASSWORD, RECOVER_PASSWORD),
    takeLatest(actions.RESET_PASSWORD, RESET_PASSWORD),
    takeLatest(actions.LOGOUT, LOGOUT),
    takeLatest(actions.CLEAR_USER, CLEAR_USER),

    takeLatest(actions.REGISTER_BUSINESS, REGISTER_BUSINESS),
    takeLatest(actions.SET_LOCATION, SET_LOCATION),
    takeEvery(actions.UPDATE_ONBOARD_STATUS, updateOnBoardStatus),
    takeEvery(actions.HANDLE_USER_TOKEN, HANDLE_USER_TOKEN),
    LOAD_CURRENT_ACCOUNT(),
  ])
}
